import cn from 'classnames';
import React from 'react';

/** A `md:` override from `className` still wins, since variants beat the base utility. */
export const DisplayHeading: React.FC<React.PropsWithChildren<{ className?: string }>> = ({ className, children }) => (
  <h1 className={cn('text-center text-h3 uppercase leading-[0.95] tracking-[-0.6px] text-eggplant', className)}>
    {children}
  </h1>
);
